import {fn} from '@convincely/utils/lib/types.js';
import {customs} from './store.js';

const defaultOriginPattern = /^https?:\/\/(?:localhost:5[0-9]{3}|(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)*?convincely\.com)$/;

export class Customiser {
  constructor(originPattern = defaultOriginPattern) {
    this.originPattern = originPattern;
    window.addEventListener('message', this.messageListener, false);
  }

  /**
   * @param {CustomsObject} data
   * @param {object} e
   * @param {WindowProxy} e.source
   * @param {string} e.origin
   */
  init(data, e) {
    this.frame = e;
    customs.set(data);
  }

  /**
   * @param {CustomsObject} data
   */
  sync(data) {
    customs.set(data);
  }

  /**
   * @param {MessageEvent} e
   * @param {MessageCommand} e.data
   */
  messageListener = (e) => {
    if (this.originPattern.test(e.origin)) {
      const {command, ...props} = e.data;

      if (typeof this[command] === fn) {
        this[e.data.command](props, e);
      }
    }
  };

  /**
   * @param {*} message
   */
  postMessage(message) {
    this.frame.source.postMessage(message, this.frame.origin);
  }
}

/**
 * @typedef {object} MessageCommand
 * @property {string} command
 */
